// https://jsfiddle.net/rockstarbingo/1a40kt75/155/

const match =
  / ((-|\/) |\()((\d{4} )?(Remaster|Edit|Mix|Stereo|Re-Recorded|Rerecorded|From|Live|Mono|Single|Full Length|Take|Radio|Extended|Full|End Title|Finale|Concert|Solo|Original|(\d{2}th Anniversary)|(\d{4})|(\d{1}" Mix)|(\d{1}'')|(.+?(?=Vocal))|(.+?(?=Version))))/i

export function convertSongTitle(input: string): string {
  return input.split(match)[0]
}
